// Remembers where to send the user after they log in, e.g. a download link
// opened from an email while logged out. sessionStorage keeps it per tab and
// survives the full-page redirect to the login screen.
const KEY = "postLoginRedirect";

const BASE = import.meta.env.VITE_APP_BASE_PATH || "";

/** True for the emailed permanent download link page, /downloads/:token. */
export const isDownloadLinkPath = (path) => /^\/downloads\/[A-Za-z0-9_-]+\/?$/.test(path.slice(BASE.length));

export const savePostLoginRedirect = (path) => {
  sessionStorage.setItem(KEY, path);
};

/** Returns the saved in-app path (and forgets it), or null. */
export const consumePostLoginRedirect = () => {
  const path = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  // Only same-app paths: "/x" but not "//evil.com".
  return path && path.startsWith("/") && !path.startsWith("//") ? path : null;
};
